import {
  Wrench, ShieldCheck, Gauge, CircleDot, Link2, Boxes, Crosshair, ScanSearch, Settings2, Cog,
  Anchor, Link, Disc3, CircleDashed, Hammer, ArrowUpFromLine, Flame, FileText,
} from "lucide-react";

// `name` must match backend SERVICES exactly
export const CATALOG = [
  { name: "Reparación de suspensión delantera y trasera", cat: "Suspensión", icon: Wrench, desc: "Revisión y reparación completa del tren delantero y trasero para recuperar estabilidad, confort y control." },
  { name: "Amortiguadores", cat: "Suspensión", icon: Gauge, desc: "Cambio de amortiguadores y bases cuando el vehículo rebota, se inclina en curvas o frena de nariz." },
  { name: "Rótulas", cat: "Suspensión", icon: CircleDot, desc: "Sustitución de rótulas con juego que provocan ruidos, desgaste irregular de llantas o inestabilidad." },
  { name: "Terminales de dirección", cat: "Dirección", icon: Link2, desc: "Cambio de terminales interiores y exteriores para eliminar juego en el volante." },
  { name: "Bujes", cat: "Suspensión", icon: Boxes, desc: "Bujes de horquilla, barra y tirantes para eliminar golpeteos y vibraciones." },
  { name: "Horquillas / brazos de control", cat: "Suspensión", icon: Crosshair, desc: "Reemplazo de horquillas superiores e inferiores dañadas o deformadas." },
  { name: "Diagnóstico de suspensión y dirección", cat: "Diagnóstico", icon: ScanSearch, desc: "Revisión a fondo para ubicar ruidos, vibraciones y fallas antes de cambiar piezas." },
  { name: "Reparación de dirección", cat: "Dirección", icon: Settings2, desc: "Atención a direcciones duras, con juego, fugas o ruidos al girar." },
  { name: "Cambio de cremallera de dirección", cat: "Dirección", icon: Cog, desc: "Reemplazo de cremallera o caja de dirección para una respuesta firme y precisa." },
  { name: "Pernos estabilizadores y gomas de barra", cat: "Suspensión", icon: Anchor, desc: "Cambio de pernos y gomas de barra estabilizadora para quitar rechinidos y golpeteos." },
  { name: "Links de barra estabilizadora", cat: "Suspensión", icon: Link, desc: "Links (tirantes) nuevos para reducir el balanceo de la carrocería en curvas." },
  { name: "Balatas", cat: "Frenos", icon: ShieldCheck, desc: "Cambio de balatas delanteras y traseras para un frenado seguro y sin ruidos." },
  { name: "Discos de freno", cat: "Frenos", icon: Disc3, desc: "Rectificado o reemplazo de discos que vibran o presentan desgaste." },
  { name: "Herrajes de caliper", cat: "Frenos", icon: CircleDashed, desc: "Herrajes, guías y limpieza de calipers para que las balatas trabajen parejo." },
  { name: "Lift spacers (levante)", cat: "Levante", icon: ArrowUpFromLine, desc: "Instalación de spacers para levantar camionetas y autos." },
  { name: "Soldadura de chasis", cat: "Estructura", icon: Flame, desc: "Reparación y refuerzo de chasis, bases y soportes con soldadura." },
  { name: "Cotización de refacciones", cat: "Refacciones", icon: FileText, desc: "Te cotizamos las piezas que tu vehículo necesita antes de cualquier trabajo." },
];

export const CATEGORIES = ["Todos", ...Array.from(new Set(CATALOG.map((s) => s.cat)))];

export const IMG = {
  hero: "/images/hero.jpg",
  bay: "/images/bay.jpg",
  assembly: "/images/assembly.jpg",
  brake: "/images/brake.jpg",
  chassis: "/images/chassis.jpg",
  garage: "/images/garage.jpg",
  shocks: "/images/shocks.jpg",
  under: "/images/under.jpg",
  fixing: "/images/fixing.jpg",
  clipboard: "/images/clipboard.jpg",
  road: "/images/road.jpg",
};

export const WEEKDAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

export { Hammer };
